import styled from 'styled-components';
import { getColor } from '@karma/components/colors';

export const InfoPageParagraphText = styled.div`
  text-align: justify;
  word-wrap: break-word;
  font-size: 18px;
  letter-spacing: 0.2px;
  line-height: 1.5;
  text-indent: 1rem;
  margin-bottom: 30px;
  color: ${getColor('neutral7')};
  font-weight: 400;

  @media (max-width: 440px) {
    font-size: 16px;
  }
`;
